import React from 'react';
import PropTypes from 'prop-types';

import WeekNavigation from "./WeekNavigation";
import moment from "moment";
import {useLocation} from 'wouter';

const WeekNavigationProvider = ({ year, week, base = '../../', showWeekend }) => {
  const [, setLocation] = useLocation();

  const handleBack = () => {
    const next = moment().isoWeekYear(year).isoWeek(week).isoWeekday(1).subtract(1, 'week')
    setLocation(`${base}${next.isoWeekYear()}/${next.isoWeek()}`);
  }

  const handleNext = () => {
    const next = moment().isoWeekYear(year).isoWeek(week).isoWeekday(1).add(1, 'week')
    setLocation(`${base}${next.isoWeekYear()}/${next.isoWeek()}`);
  }

  return (
    <WeekNavigation
      year={year}
      week={week}
      handleBack={handleBack}
      handleNext={handleNext}
      showWeekend={showWeekend}
    />
  );
}

WeekNavigationProvider.propTypes = {
  year: PropTypes.number,
  month: PropTypes.number,
  showWeekend: PropTypes.bool,
}

export default WeekNavigationProvider;

